import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import createToolbar from './toolbar';
import { createBasePlugin, PLUGIN_DECORATION_PROPS, PLUGIN_DECORATIONS } from 'wix-rich-content-plugin-commons';
import BadPlugin from '../../components/BadPlugin';
import { IMAGE_TYPE, IMAGE_TYPE_LEGACY, getDefaultComponentData } from './types';
import imageComponentWrapper from './components/ImageComponentWrapper/image-component-wrapper';
import DeviationMediaService from '../../../utils/DeviationMediaService';
function imagePluginCreator(pluginConfig) {
    return (config = {})=>{
        const { decorator, helpers, t, theme, isMobile, anchorTarget, relValue, image } = config, rest = _object_without_properties(config, [
            "decorator",
            "helpers",
            "t",
            "theme",
            "isMobile",
            "anchorTarget",
            "relValue",
            "image"
        ]);
        return createBasePlugin(_object_spread({
            component: pluginConfig.component ? imageComponentWrapper(pluginConfig.component) : BadPlugin,
            pluginDecorationProps: (props, componentData)=>{
                var _componentData_config;
                if (!pluginConfig.allowResize) {
                    return {};
                }
                // Resizeable logic depending on given size
                const size = (_componentData_config = componentData.config) === null || _componentData_config === void 0 ? void 0 : _componentData_config.size;
                let calulatedProps = props;
                if (size === 'original' && componentData.deviationId) {
                    const fv = DeviationMediaService.getLargestFullview(componentData.data);
                    if (fv.width) {
                        calulatedProps = _object_spread_props(_object_spread({}, props), {
                            width: fv.width,
                            style: {
                                width: fv.width
                            }
                        });
                    }
                }
                const resizeableProps = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](calulatedProps);
                if (size === 'inline') {
                    return resizeableProps;
                } else if (size === 'original') {
                    return _object_spread_props(_object_spread({}, resizeableProps), {
                        style: _object_spread_props(_object_spread({}, resizeableProps.style), {
                            maxWidth: '100%'
                        })
                    });
                } else {
                    const _resizeableProps_style = resizeableProps.style, { width } = _resizeableProps_style, allButWidth = _object_without_properties(_resizeableProps_style, [
                        "width"
                    ]); // eslint-disable-line no-unused-vars
                    return _object_spread_props(_object_spread({}, resizeableProps), {
                        style: _object_spread({}, allButWidth)
                    });
                }
            },
            componentWillReceiveDecorationProps: (props, nextProps, onPropsChange)=>{
                const { width } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](props);
                const { width: nextWidth } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](nextProps);
                if (width !== nextWidth) {
                    onPropsChange({
                        size: 'inline',
                        width: nextWidth
                    });
                }
            },
            decorator,
            settings: _object_spread({}, pluginConfig, image),
            theme,
            type: IMAGE_TYPE,
            legacyType: IMAGE_TYPE_LEGACY,
            toolbar: createToolbar({
                helpers,
                anchorTarget,
                relValue,
                t,
                pluginConfig
            }),
            helpers,
            isMobile,
            anchorTarget,
            relValue,
            t,
            defaultPluginData: getDefaultComponentData()
        }, rest), {});
    };
}
export { imagePluginCreator };

//# sourceMappingURL=createImagePlugin.js.map